/**
 * 设备检测工具
 * 用于检测当前设备是否为移动端
 */

/**
 * 检测是否为移动端设备
 * @returns {boolean} 如果是移动端返回true，否则返回false
 */
export function isMobileDevice() {
  // 方法1: 通过 userAgent 检测
  const ua = navigator.userAgent.toLowerCase()
  const mobileKeywords = [
    'android',
    'iphone',
    'ipad',
    'ipod',
    'blackberry',
    'windows phone',
    'mobile',
    'webos',
    'opera mini',
    'iemobile',
    'wpdesktop'
  ]
  
  const isMobileUA = mobileKeywords.some(keyword => ua.includes(keyword))
  
  // 方法2: 通过屏幕宽度检测（可选，作为辅助判断）
  const isMobileWidth = window.innerWidth <= 768
  
  // 方法3: 检测触摸事件支持
  const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0
  
  // 综合判断：优先使用 UA 检测，屏幕宽度作为辅助
  return isMobileUA || (isMobileWidth && isTouchDevice)
}

/**
 * 获取设备类型
 * @returns {string} 'mobile' | 'tablet' | 'desktop'
 */
export function getDeviceType() {
  const ua = navigator.userAgent.toLowerCase()
  const width = window.innerWidth
  
  // 检测是否为平板
  if ((ua.includes('ipad') || (ua.includes('android') && !ua.includes('mobile'))) && width >= 768) {
    return 'tablet'
  }
  
  // 检测是否为移动端
  if (isMobileDevice()) {
    return 'mobile'
  }
  
  return 'desktop'
}

/**
 * 检测是否为微信/企业微信环境
 * @returns {object} { isWeChat: boolean, isWorkWeChat: boolean }
 */
export function isWeChatEnvironment() {
  const ua = navigator.userAgent.toLowerCase()
  return {
    isWeChat: ua.includes('micromessenger'),
    isWorkWeChat: ua.includes('wxwork')
  }
}

/**
 * 检测是否为钉钉环境
 * @returns {boolean}
 */
export function isDingTalkEnvironment() {
  const ua = navigator.userAgent.toLowerCase()
  return ua.includes('dingtalk')
}

/**
 * 检测是否为飞书环境
 * @returns {boolean}
 */
export function isLarkEnvironment() {
  const ua = navigator.userAgent.toLowerCase()
  return ua.includes('lark') || ua.includes('feishu')
}

/**
 * 检测是否为飞书环境（更可靠：优先 SDK 注入特征，其次 UA 兜底）
 * @returns {boolean}
 */
export function isFeishuEnvironment() {
  try {
    // 飞书 H5SDK 环境特征（参考业务侧判断：window.h5sdk && window.tt）
    if (typeof window !== 'undefined' && window?.h5sdk && window?.tt) return true
  } catch (e) {
    // ignore
  }
  return isLarkEnvironment()
}

